export const scrollToTopOfPage = () => {
  window.scrollTo(0, 0);
};
